<template>
  <vue-final-modal
    v-model="showModal"
    classes="modal-container"
    content-class="modal-content"
    name="newsletter"
    @click-outside="closeModal"
  >
    <slot v-bind="{ closeModal }"></slot>
  </vue-final-modal>
</template>

<script>
export default {
  data() {
    return {
      showModal: true
    }
  },
  methods: {
    closeModal() {
      this.showModal = false
    }
  }
}
</script>
